export default "__VITE_ASSET__a495e5eb__"